import {Component} from '@angular/core';
import {AbstractGenericGridSimpleSearchFieldComponent} from './abstract-generic-grid-simple-search-field.component';

@Component({
  selector: 'app-generic-grid-simple-search-field-text',
  template: `
    <input
      [(ngModel)]="this.field.value"
      type="search"
      pInputText
      placeholder="{{ 'FILTER_MANAGEMENT.MATCH_MODE_CONTAINS' | translate }}"
    />
  `
})
export class GenericGridSimpleSearchFieldTextComponent extends AbstractGenericGridSimpleSearchFieldComponent {

}
